class RunningTotal extends HTMLElement {
    constructor() {
        super();
        console.log('loaded');
        $(this).on('click', (event) => {
            console.log('clicked');

            const container = $('.price-container');
            const dialog = $('.running-total__dialog');
            dialog.toggleClass('d-none');
            // container.append(dialog);

            const backdrop = $('<div class="running-total__backdrop"></div>');
            backdrop.on('click', (event) => {
                dialog.toggleClass('d-none');
                backdrop.remove();
            });

            $('body').append(backdrop);
            $('body').append(dialog);
        });
    }
}
//customElements.define('running-total', RunningTotal);

$(document).ready(() => {
    console.log('ready ......');
    // $('.running-total__dialog .hide-dialog').on('click', (event) => {
    //     console.log('clicked ......');
    //     const dialog = $('.running-total__dialog');
    //     dialog.addClass('d-none');

    //     const backdrop = $('.running-total__backdrop');
    //     backdrop?.remove();
    // });

    // $(document).on('click', (event) => {
    //     console.log('clicked ......', event.target);
    //     const dialog = $('.running-total__dialog');

    //     if (!dialog.is(event.target) && dialog.has(event.target).length === 0 && dialog.hasClass('d-none') === false) {
    //         // dialog.addClass('d-none');
    //     }
    // });
    
});